<section class="login-page">
  <div class="login-card">
    <div class="login-brand">
      <img *ngIf="logo" class="login-brand-logo" [src]="logo" alt="Logo do empregador">
      <span *ngIf="!logo" class="login-brand-mark">{{ iniciais }}</span>
      <div>
        <div class="login-brand-name">{{ nomeEmpresa }}</div>
        <div class="login-brand-subtitle">Sistema de ponto eletronico web</div>
      </div>
    </div>

    <h2>Bem-vindo!</h2>
    <p class="login-muted">Faca login na sua conta</p>

    <form class="login-form" (ngSubmit)="entrar.emit()">
      <input
        class="form-control login-input"
        type="email"
        name="loginEmail"
        [(ngModel)]="formulario.email"
        placeholder="E-mail"
        autocomplete="email"
        required>

      <div class="input-group login-password">
        <input
          class="form-control login-input"
          [type]="senhaVisivel ? 'text' : 'password'"
          name="loginSenha"
          [(ngModel)]="formulario.senha"
          placeholder="Senha"
          autocomplete="current-password"
          required>
        <button
          type="button"
          class="login-eye"
          (click)="senhaVisivel = !senhaVisivel"
          [attr.aria-label]="senhaVisivel ? 'Ocultar senha' : 'Mostrar senha'">
          <i class="bi" [ngClass]="senhaVisivel ? 'bi-eye-slash' : 'bi-eye'"></i>
        </button>
      </div>

      <div class="login-options">
        <span></span>
        <button type="button" class="login-link" disabled>Esqueceu a senha?</button>
      </div>

      <button class="login-submit">Login</button>
    </form>

    <div class="login-footer" *ngIf="primeiroAcesso">
      Ainda nao tem conta?
      <button type="button" class="login-link login-link-primary" (click)="criarPrimeiroAcesso.emit()">Cadastre-se agora</button>
    </div>
  </div>
</section>
